import { Box, styled } from "@mui/material";
import { BodyTextM } from "../Typography";


export const InputRootWrapper = styled(Box)(({ theme }) => (
    theme.unstable_sx({
        display: "flex",
        flexDirection: "column"
    })
));

export const InputControlWrapper = styled(Box)(({ theme }) => (
    theme.unstable_sx({
        display: "flex",
        alignItems: "center"
    })
));

export const InputLabel = styled(BodyTextM)(({ theme }) => (
    theme.unstable_sx({
        fontWeight: 700,
        transform: "none",
        marginBottom: theme.spacing(2),
        color: theme.palette.grey["800"],

        "&.Mui-focused": {
            color: theme.palette.grey["600"]
        },
    })
));

export const InputSubLabel = styled(BodyTextM)(({ theme }) => (
    theme.unstable_sx({
        fontWeight: 400,
        whiteSpace: "normal",
        paddingLeft: "73px",
        cursor: "pointer",
        color: theme.palette.grey["600"]
    })
));

export const InputSubLabelNoPadding = styled(BodyTextM)(({ theme }) => (
    theme.unstable_sx({
        fontWeight: 400,
        whiteSpace: "normal",
        paddingLeft: "0px",
        cursor: "pointer",
        color: theme.palette.grey["600"]
    })
));

export const InputRequiredMark = styled("span")(({ theme }) => (
    theme.unstable_sx({
        "&:before": {
            content: '"*"',
            ml: theme.spacing(1),
            verticalAlign: "middle",
            color: theme.palette.error.main
        }
    })
));